import React, { memo } from "react";
import { Button } from "@material-ui/core";
import { globalClasses } from "../ThemeProvider";

// props are spread as below directly to prevent inconsistent look of the buttons
// do not modify; if needed to have other look, use standard Button component
// or create other custom button wrapper
function ErrorButtonContained({ color, variant, className, ...rest }) {
  return (
    <Button
      classes={{ root: globalClasses.filledButtonError }}
      variant="contained"
      {...rest}
    />
  );
}
export default memo(ErrorButtonContained);
